import React from 'react';
import PropTypes from 'prop-types';

import '../stages/Introduction.css'

export default function Card({ text, image }) {

    return (
        <div className='benefit-card vertical-content'>
            <div className='horizontal-content top-content'>
                <div className='benefit-bullet-container top-content'>
                    <img className='benefit-bullet' src='imgs/intro/benefits/bullet.png' alt='Bullet'/>
                </div>
                <div className='benefit-text-paragraph text-small'> { text } </div>
            </div>
            <img className='benefit-image' src={`imgs/intro/benefits/${ image }.png`} alt={ image }/>
        </div>
    )
}

Card.propTypes = {
    text: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired
};
